export enum SearchType {
  inspections,
  items,
}
